module.exports = __webpack_public_path__ + "static/img/heat-treatmentC.3bc7d1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heat-treatmentC.png
// module id = GYPQ
// module chunks = 1